import { useEffect, type ReactNode } from 'react'
import { Link } from 'react-router'
import Header from '../sections/Header'
import Footer from '../sections/Footer'

interface PageShellProps {
  title: string
  intro: string
  children: ReactNode
}

/** Shared layout for standalone marketing pages (sub-pages of the homepage). */
export default function PageShell({ title, intro, children }: PageShellProps) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="relative">
      <Header />
      <main className="pt-24 pb-20 bg-[#0d1117] min-h-screen">
        <div className="max-w-[960px] mx-auto px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-[#06b6d4] hover:text-[#22d3ee] transition-colors mb-8"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Back to Home
          </Link>
          <h1 className="text-[clamp(28px,3vw,42px)] font-semibold leading-[1.15] tracking-[-0.015em] text-white mb-4">
            {title}
          </h1>
          <p className="text-[clamp(16px,1.5vw,19px)] leading-[1.6] text-[#9ca3af] mb-12 max-w-[720px]">
            {intro}
          </p>
          {children}
        </div>
      </main>
      <Footer />
    </div>
  )
}
